import React from 'react';
import Icon from '../../../components/AppIcon';

const CarrierManagement = ({ carriers, onUpdate }) => {
  const getReliabilityColor = (score) => {
    if (score >= 4.5) return 'text-green-600';
    if (score >= 4.0) return 'text-blue-600';
    if (score >= 3.5) return 'text-yellow-600';
    return 'text-red-600';
  };

  return (
    <div className="space-y-4">
      <div className="bg-card rounded-xl p-6 border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4">
          Kargo Firmaları Yönetimi
        </h3>
        <p className="text-sm text-muted-foreground mb-6">
          Aktif kargo firmalarının performans metrikleri ve maliyet bilgileri
        </p>

        <div className="space-y-4">
          {carriers?.map((carrier) => (
            <div 
              key={carrier?.id}
              className="bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition-colors"
            >
              <div className="flex items-start justify-between mb-3">
                <div>
                  <h4 className="font-semibold text-foreground mb-1">
                    {carrier?.carrierName}
                  </h4>
                  <p className="text-xs text-muted-foreground font-mono">
                    {carrier?.carrierCode}
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <Icon name="Star" size={16} className={getReliabilityColor(carrier?.reliabilityScore)} />
                  <span className={`font-semibold ${getReliabilityColor(carrier?.reliabilityScore)}`}>
                    {carrier?.reliabilityScore?.toFixed(1)}
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                <div>
                  <p className="text-muted-foreground mb-1">Maliyet</p>
                  <p className="font-medium text-foreground">
                    {carrier?.costPerKg?.toFixed(2)} TL/kg
                  </p>
                </div>
                <div>
                  <p className="text-muted-foreground mb-1">Ortalama Teslimat</p>
                  <p className="font-medium text-foreground">
                    {carrier?.averageDeliveryDays} gün
                  </p>
                </div>
                <div>
                  <p className="text-muted-foreground mb-1">Güvenilirlik</p>
                  <p className="font-medium text-foreground">
                    {((carrier?.reliabilityScore / 5) * 100)?.toFixed(0)}%
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Carrier Comparison */}
      <div className="bg-card rounded-xl p-6 border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4">
          Kargo Firması Karşılaştırması
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-border">
                <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">Firma</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">Maliyet</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">Hız</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">Güvenilirlik</th>
              </tr>
            </thead>
            <tbody>
              {carriers
                ?.sort((a, b) => b?.reliabilityScore - a?.reliabilityScore)
                ?.map((carrier) => (
                  <tr key={carrier?.id} className="border-b border-border last:border-0">
                    <td className="py-3 px-4 text-sm font-medium text-foreground">
                      {carrier?.carrierName}
                    </td>
                    <td className="py-3 px-4 text-sm text-foreground">
                      {carrier?.costPerKg?.toFixed(2)} TL/kg
                    </td>
                    <td className="py-3 px-4 text-sm text-foreground">
                      {carrier?.averageDeliveryDays} gün
                    </td>
                    <td className="py-3 px-4">
                      <div className="flex items-center gap-2">
                        <div className="flex-1 bg-gray-200 rounded-full h-2">
                          <div 
                            className="bg-primary rounded-full h-2"
                            style={{ width: `${(carrier?.reliabilityScore / 5) * 100}%` }}
                          />
                        </div>
                        <span className="text-sm font-medium text-foreground">
                          {carrier?.reliabilityScore?.toFixed(1)}
                        </span>
                      </div>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CarrierManagement;